import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import Color from '@tiptap/extension-color';
import { TextStyle } from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import Image from '@tiptap/extension-image';
import Mention from '@tiptap/extension-mention';
import Placeholder from '@tiptap/extension-placeholder';

const CustomImage = Image.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            width: {
                default: null,
                parseHTML: (element) => element.getAttribute('width'),
                renderHTML: (attributes) => (attributes.width ? { width: attributes.width } : {}),
            },
            height: {
                default: null,
                parseHTML: (element) => element.getAttribute('height'),
                renderHTML: (attributes) => (attributes.height ? { height: attributes.height } : {}),
            },
            style: {
                default: null,
                parseHTML: (element) => element.getAttribute('style'),
                renderHTML: (attributes) => (attributes.style ? { style: attributes.style } : {}),
            },
            'data-emoji': {
                default: null,
                parseHTML: (element) => element.getAttribute('data-emoji'),
                renderHTML: (attributes) => (attributes['data-emoji'] ? { 'data-emoji': attributes['data-emoji'] } : {}),
            },
        } as any;
    },
});

const CustomMention = Mention.extend({
    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: (element) => element.getAttribute('data-code') || element.getAttribute('data-id'),
                renderHTML: (attributes) => (attributes.id ? { 'data-code': attributes.id } : {}),
            },
            label: {
                default: null,
                parseHTML: (element) => (element.textContent || '').replace(/^@/, '').trim(),
                renderHTML: () => ({}),
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'span[class*="member"]',
                getAttrs: (element: HTMLElement) => {
                    const id = element.getAttribute('data-code') || element.getAttribute('data-id');
                    if (!id) return false;
                    const label = (element.textContent || '').replace(/^@/, '').trim();
                    return { id, label: label || id };
                },
            },
        ];
    },
});

const starterKit = StarterKit.configure({
    paragraph: {
        HTMLAttributes: {
            class: 'editor-paragraph',
        },
    },
});

const configuredImage = CustomImage.configure({
    inline: true,
    allowBase64: true,
    HTMLAttributes: {
        class: 'editor-image',
    },
});

const feedbackPlaceholder = `请描述你遇到的问题，尽可能包括：
1、在什么场景下遇到什么问题；
2、你的操作步骤是什么。`;

/** H5 反馈编辑器扩展（模块级单例，避免 useEditor 反复重建） */
export const feedbackEditorExtensionsH5 = [
    starterKit,
    Link,
    Color,
    TextStyle,
    Underline,
    configuredImage,
    Placeholder.configure({ placeholder: feedbackPlaceholder }),
];

/** PC 反馈编辑器扩展（含 Mention 回显） */
export const feedbackEditorExtensionsPC = [
    starterKit,
    Link,
    Color,
    TextStyle,
    Underline,
    configuredImage,
    CustomMention.configure({
        HTMLAttributes: {
            class: 'member',
        },
        renderLabel({ node }) {
            return `@${node.attrs.label || node.attrs.id}`;
        },
    }),
    Placeholder.configure({ placeholder: feedbackPlaceholder }),
];
